import { render, staticRenderFns } from "./TreeNode.vue?vue&type=template&id=1036d808&scoped=true&"
import script from "./TreeNode.vue?vue&type=script&lang=js&"
export * from "./TreeNode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1036d808",
  null
  
)

export default component.exports